import { Employee } from "@/v2/types";
import ArFormCombobox from "../form/ComboBoxFormField";
import { FieldValues, Path } from "react-hook-form";
import FindAllEmployees from "@/v2/api/employee/FindAll";

export function EmployeeComboBox<T extends FieldValues>({
    name,
    storeFullObject = false,
    setSelectedEmployee,
    defaultValue,
}: {
    name: Path<T>;
    storeFullObject?: boolean;
    setSelectedEmployee: (value: Employee | null) => void;
    defaultValue: Employee | null;
}) {
    return (
        <ArFormCombobox<T, Employee>
            defaultValue={defaultValue}
            name={name}
            label="Select Employee"
            queryKey="employees"
            queryFn={async ({ pageParam, search, limit }) =>
                FindAllEmployees({
                    skip: pageParam,
                    limit,
                    search,
                })
            }
            getDisplayValue={(employee) => employee.full_name}
            renderItem={(employee) => (
                <div className="flex flex-col">
                    <span>{employee.full_name}</span>
                    {employee.iqama && (
                        <span className="text-xs text-muted-foreground">
                            {employee.iqama}
                        </span>
                    )}
                    {employee.trade && (
                        <span className="text-xs text-muted-foreground">
                            Trade : {employee.trade[0]}
                        </span>
                    )}
                </div>
            )}
            placeholder="Select employee..."
            width="w-full"
            storeFullObject={storeFullObject}
            onItemSelect={(employee: Employee | null) => {
                setSelectedEmployee(employee);
            }}
        />
    );
}
